import api from "../services/api";

const login = async credentials => {
    const {data} = await api.post('/user/login/', credentials);
    return data;
}
export default { login }